import React, { useContext, useEffect, useState } from "react";

// ui
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";

// components
import { useIntl } from "react-intl";
import AvatarBasic from "../../../../common/components/avatar/AvatarBasic";
// style

// store
import { StoreContext } from "../../../../store/StoreProvider";
import Act from "../../../../store/actions";
import useModulePublic from "../../../hooks/useModulePublic";

// config, utils
import { sideToolConfig } from "../../config";
//
import defaultGroupIcon from "../../../../../images/avatar_group/avatar_group.svg";
import { isEmpty } from "../../../../common/utils";

const GroupAvatar = () => {
  // route,intl
  const intl = useIntl();
  //
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { sidebar } = sna;
  const { group, groups } = user;
  // hooks
  const { handlePublic } = useModulePublic();
  //

  const handleClick = () => {
    const curToolName = "group";
    if (curToolName === sidebar.contentName) {
      dispatch({
        type: Act.SNA_SIDE_BAR,
        payload: { ...sidebar, open: !sidebar.open, contentName: curToolName },
      });
    } else {
      dispatch({
        type: Act.SNA_SIDE_BAR,
        payload: { ...sidebar, open: true, contentName: curToolName },
      });
    }
  };

  const groupConfig = sideToolConfig.group;
  const handleDisabled = (item) => !handlePublic(item.moduleId);
  const getAvatarProps = () => {
    const defaultGroupName = "預設團隊";
    const groupName = group.name || group.displayName;
    if (groupName === defaultGroupName) {
      return {
        letter: groupName,
        src: defaultGroupIcon,
      };
    }
    return {
      letter: groupName,
    };
  };

  const getTooltipProps = () => {
    const defaultGroupName = "預設團隊";
    const groupName = group.name || group.displayName;
    if (groupName === defaultGroupName) {
      return {
        title: intl.formatMessage({
          id: groupConfig.intl18Id,
          defaultMessage: "預設團隊",
        }),
      };
    }
    return {
      title: groupName || "",
    };
  };

  return (
    !isEmpty(group) && (
      <Box mb={2}>
        <IconButton
          onClick={handleClick}
          disabled={handleDisabled(groupConfig)}
          sx={{ padding: "0px" }}
        >
          <AvatarBasic
            avatarProps={{
              ...getAvatarProps(),
              sx: {
                width: 32,
                height: 32,
                fontSize: "12px",
              },
            }}
            tooltipProps={{
              ...getTooltipProps(),
            }}
          />
        </IconButton>
      </Box>
    )
  );
};

export default GroupAvatar;
